export enum FeatureFlag {
  FrontendUnleashSmokeTest = 'frontend-unleash-smoke-test',
  TopMessageBar = 'top-message-bar',
  /** Multi-method shipping selector at checkout. Off = legacy flat shipping fee. */
  ShippingMethods = 'shipping-methods',
  ShipmentTracking = 'shipment-tracking',
  /** Witro (non-tenant) live homepage. Disabled → Coming Soon page. */
  ShopperWitroHomepage = 'shopper-witro-homepage',
  /** Show the experimental release badge in the Witro marketplace navbar. */
  ShopperWitroBetaBadge = 'shopper-witro-beta-badge',
  /**
   * Witro marketplace navbar search (homepage, PLP, PDP, etc.).
   * Off = hide search until the new Witro search is ready.
   * Tenant storefronts are not gated by this flag.
   */
  ShopperWitroSearch = 'shopper-witro-search',
}
